const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

const ALL_MASCOTS = [
  { name: "KAI", file: "asset_mascot_kai.jpg", tagline: "Le guerrier KAIZEN", desc: "Force, sagesse et discipline — le gardien de l'esprit du dojo.", accent: "#c9a961" },
  { name: "MEI", file: "asset_mascot_mei.jpg", tagline: "PowerKick Her", desc: "L'énergie du kickboxing au féminin — puissance, grâce et confiance.", accent: "#ec4899" },
  { name: "LANA", file: "asset_mascot_lana.jpg", tagline: "La force de la communauté", desc: "Diversité, inclusion et dépassement — la grande famille KAIZEN.", accent: "#a855f7" },
];

/**
 * Bandeau réutilisable des 3 mascottes officielles KAIZEN (KAI · MEI · LANA).
 * Props :
 *  - title / subtitle : textes d'en-tête
 *  - order : tableau de noms pour réordonner/mettre en avant (ex: ["MEI","KAI","LANA"])
 *  - className : classes utilitaires additionnelles sur la section
 */
export default function MascotBand({
  title = "L'esprit KAIZEN, incarné",
  subtitle = "KAI, MEI et LANA t'accompagnent du premier cours jusqu'à ta meilleure version.",
  order = null,
  className = "",
}) {
  let mascots = ALL_MASCOTS;
  if (order && Array.isArray(order)) {
    mascots = order
      .map((n) => ALL_MASCOTS.find((m) => m.name === n))
      .filter(Boolean);
  }

  return (
    <section data-testid="mascot-band" className={`max-w-6xl mx-auto px-6 ${className}`}>
      <div className="rounded-2xl border border-white/10 bg-[#0d0d0d] p-6 sm:p-8">
        <div className="text-[10px] tracking-[0.3em] uppercase mb-2 text-[#c9a961]" data-testid="mascot-band-eyebrow">— Nos ambassadeurs</div>
        <h3 className="font-black tracking-tight text-2xl sm:text-3xl mb-2 text-white" style={{ fontFamily: "'Barlow Condensed', 'Cabinet Grotesk', sans-serif" }}>
          {title}
        </h3>
        <p className="text-white/55 text-sm max-w-2xl mb-6 leading-relaxed">{subtitle}</p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          {mascots.map((m) => (
            <div key={m.name} data-testid={`mascot-band-${m.name.toLowerCase()}`}
              className="group flex items-center gap-4 rounded-xl border border-white/10 bg-[#141414] p-3 hover:border-[var(--a)] transition-colors duration-300"
              style={{ "--a": m.accent }}>
              <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0 relative">
                <img src={`${BACKEND}/api/marketing-assets/file/${m.file}`} alt={m.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              </div>
              <div className="min-w-0">
                <div className="text-xs font-black tracking-[0.2em]" style={{ color: m.accent }}>{m.name}</div>
                <div className="text-sm font-bold text-white leading-tight" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>{m.tagline}</div>
                <div className="text-[11px] text-white/45 leading-snug mt-0.5">{m.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
